import type { W_Job_JobPreview_VM, W_Job_JobPreview_VM_WorkRequestPreviewDetails } from 'ab-api/web/job/findByIdForPreview';

import type { WorkOrderTableViewModel } from 'ab-viewModels/workOrderTable.viewModel';

import type { JobOutletContext } from 'af-components/SharedPreviews/WorkRequest/Details/types';
import type { TableRef } from 'af-components/Table';
import type { TableProps } from 'af-components/Table/types';

export type JobPreviewOutletContext<T = WorkOrderTableViewModel> = JobOutletContext & TableProps<T> & {
	jobId: number;
	jobHazardAssessment: W_Job_JobPreview_VM['jobHazardAssessment'];
	jobCode: string;
	billingContact: W_Job_JobPreview_VM_WorkRequestPreviewDetails['billingContact'];
	isSendingInvoiceNotificationsEnabled: boolean;
	ref: React.RefObject<Nullable<TableRef<T>>>;
	jobMaterials: W_Job_JobPreview_VM['jobMaterials'];
};

export enum JobPreviewTabRoutes {
	DETAILS = 'details',
	BILLING_CODES = 'billingCodes',
	JOB_HAZARD_ASSESSMENT = 'jobHazardAssessment',
	ATTACHMENTS = 'attachments',
	RELATED_WORK_ORDERS = 'relatedWorkOrders',
	WORK_SUMMARY = 'workSummary',
	INVOICES = 'invoices',
	JOB_TRACKING = 'jobTracking',
	MATERIALS = 'materials'
}
